const registerConfidentialIconToggle = () => {
  $(function () {
    $(document).on('click', '#id_is_confidential', function() {
      if ($(this).is(':checked')) {
        $( '.confidential-icon' ).css('display', '');
      } else {
        $( '.confidential-icon' ).css('display', 'none');
      }
    });
  });
};

const registerConfidentialIconDisplay = () => {
  $(function () {
    if ($('#id_is_confidential').is(':checked')) {
      $( '.confidential-icon' ).css('display', '');
    }
  });
};

const registerConfidentialRoutinesEdit = () => {
  registerConfidentialIconToggle();
  registerConfidentialIconDisplay();
};

window.registerConfidentialRoutinesEdit = registerConfidentialRoutinesEdit;
